// extracted by mini-css-extract-plugin
module.exports = {"printable":"styles_printable__MNqLT","nonPrintable":"styles_nonPrintable__opxXB","button":"styles_button__EHNFw","reduceSize":"styles_reduceSize__LGhYl"};